export default "__VITE_ASSET__DDsQeitx__"